// How a `/dashboard/...` path splits into the three segments the loaders take.
//
// Mirrors `dashboardRoute` in apps/pictufy/src/views/data/dashboard/index.ts, which is the
// authority — that is where the segments are consumed. The duplication is deliberate and
// small: the client needs to parse a URL it is about to navigate to, before any request
// goes out, and a round trip to ask the server how to read its own URL would be absurd.
// Keep the two in step; there is nothing else in either file.
//
// Mind the pseudo-tabs. `include-hidden` is not a tab — it loads the resellers tab with
// hidden rows — and `weekly` / `monthly` / `yearly` all load overview with a different
// `periodMode`. Both are why `tab` is a plain string rather than a union here.

export interface DashboardRoute {
  /** `$da[2]`, defaulted. */
  tab: string;
  /** `$da[3]` — sub-tab, employee filter, or "". */
  subtab: string;
  /** `$da[4]` — artist filter, sort flag, or "". */
  filter: string;
}

export function dashboardRoute(pathname: string): DashboardRoute {
  const da = pathname.split("/");
  return { tab: da[2] || "overview", subtab: da[3] ?? "", filter: da[4] ?? "" };
}
